<template>
  <DialogBase
    title="Đổi khối cho lớp"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-sort"
    panel-icon-tone="warning"
    panel-title="Đổi khối cho lớp"
    panel-subtitle="Chuyển lớp sang khối học khác"
    :confirm-loading="loadingButton"
    :confirm-disabled="!showSaveChange"
    confirm-text="Lưu"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSave"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      label-position="top"
    >
      <div class="sk-form-grid">
        <el-form-item label="Tên khối hiện tại">
          <el-input disabled :value="dataForm.gradeName" />
        </el-form-item>
        <el-form-item label="Tên lớp">
          <el-input disabled :value="dataForm.className" />
        </el-form-item>
      </div>

      <el-form-item label="Chọn khối mới" prop="idGrade" class="sk-u-mt-12">
        <el-select
          v-model="dataForm.idGrade"
          placeholder="Chọn khối"
          clearable
          class="sk-u-w-full"
          @change="handleGradeChange"
        >
          <el-option
            v-for="item in gradeList"
            :key="item.id"
            :value="item.id"
            :label="item.gradeName"
          />
        </el-select>
        <span v-if="customErrorMessages.newNameKt" class="sk-note sk-note--danger sk-u-mt-12">
          <i class="el-icon-warning-outline" />
          <span>{{ customErrorMessages.newNameKt }}</span>
        </span>
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import GradeService from "@/services/GradeService";
import MaClassService from "@/services/MaClassService";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {
        id: "",
        idGrade: "",
        className: "",
        gradeName: "",
      },
      customErrorMessages: {
        newNameKt: "",
      },
      classList: [],
      showSaveChange: false,
      gradeList: [],
      newClassCreated: null,
      loadingButton: false,
    };
  },
  methods: {
    handleClose(done) {
      this.$emit("dialog-close");
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields();
        }
      });
      if (typeof done === "function") done();
    },

    handleSave() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          MaClassService.changeGradeService(this.dataForm)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.loadingButton = false;
            });
        }
      });
    },

    handleGradeChange() {
      for (let i = 0; i < this.gradeList.length; i++) {
        if (this.dataForm.idGrade === "") {
          this.customErrorMessages.newNameKt =
            "Giá trị không được để trống!";
          this.showSaveChange = false;
          break;
        } else {
          this.showSaveChange = true;
          this.customErrorMessages.newNameKt = "";
        }
      }
    },

    async getDataInitial(row) {
      this.dataForm.id = row.id;
      this.dataForm.className = row.className;
      this.dataForm.gradeName = row.grade.gradeName;
      await GradeService.getGradeInPrinciple().then((resp) => {
        this.gradeList = resp.data.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>